export const formIds = {
	womac: "28e49946-4c5e-4bf0-b6ea-7b73803b3e27", // WOMAC Osteoarthritis Index
	eq5d: "c6b5cdc2-d3d8-44a8-8bd5-3db2696464bf", // EQ-5D-5L Health Questionnaire
	painScore: "20c05eda-61ba-4531-b3ca-5811ea7c6970", // Pain Score
	oxfordKnee: "e2f876c1-4b4c-4a9e-a338-b6d7b9eb1e1f", // Oxford Knee Score
};
